import { render } from "./NewProduct.vue?vue&type=template&id=03397133"
import script from "./NewProduct.vue?vue&type=script&lang=js"
export * from "./NewProduct.vue?vue&type=script&lang=js"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__